import { render, staticRenderFns } from "./cardInputNumber.vue?vue&type=template&id=f107af1c&scoped=true&"
import script from "./cardInputNumber.vue?vue&type=script&lang=js&"
export * from "./cardInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./cardInputNumber.vue?vue&type=style&index=0&id=f107af1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f107af1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
